//import firebase from './Firebase.js'
//import { Capacitor } from '@capacitor/core';
//import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";

// ----------------------------- o

export default {
    async logEvent(obj) {
        console.log('logEvent obj', obj)
        FirebaseAnalytics.logEvent(obj) // working
        // firebase.analytics().logEvent(obj) // not working
    }
}